/**
 * @name 上传树组件
 */
import base from '../../base';
import UploadTree from './UploadTree';

UploadTree.install = function(Vue) {
  Vue.use(base);
  Vue.component(UploadTree.name, UploadTree);
};

export default UploadTree;
